import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-mentorlist",
  templateUrl: "./mentorlist.component.html",
  styleUrls: ["./mentorlist.component.css"],
})
export class MentorlistComponent implements OnInit {
  mentorlist: any;
  mentorlist1: any;
  mentorlist2: any;
  sector1: any;
  sector2: any;
  sectorsame: boolean = false;
  sector1name: any;
  sector2name: any;
  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.sector1 = true;
    this.sector2 = false;
    this.sector1name = localStorage.getItem("sector1");
    this.sector2name = localStorage.getItem("sector2");
    if (this.sector1name == this.sector2name) {
      this.sectorsame = true;
    }
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    var body: any = new FormData();
    body.append("sector1", this.sector1name);
    body.append("sector2", this.sector2name);
    this.http
      .post(environment.API_URL + "getmentors/", body, { headers })
      .subscribe((Response) => {
        this.mentorlist = Response;
        this.mentorlist1 = this.mentorlist.sector1mentors;
        this.mentorlist2 = this.mentorlist.sector2mentors;
      });
  }

  switchtab(sec: any) {
    if (sec == 1) {
      this.sector1 = true;
      this.sector2 = false;
    } else if (sec == 2) {
      this.sector2 = true;
      this.sector1 = false;
    }
  }
}
